import { use } from 'react';

import { GripVertical } from 'lucide-react';

import { SortableRowContext } from './row-drag-handle-context';

export type HandleUpdateProps = (id: number, name: string, v: string | number) => void;
export type HandleDelete = (id: number) => void;

export function RowDragHandleCell() {
  const context = use(SortableRowContext);

  return (
    <button
      className="dark:text-accent-x-light cursor-grab rounded-xl p-1.5 opacity-40 hover:bg-gray-200 hover:opacity-100 dark:hover:bg-gray-900"
      ref={context?.handleRef}
      type="button"
    >
      <GripVertical size={16} />
    </button>
  );
}
